export { default as GDMCustomInputLabel } from './GDMCustomInputLabel';

export type {
  GDMCustomInputLabelComponent,
  GDMCustomInputLabelProps,
} from './GDMCustomInputLabel.type';
